<app-permissions-form
  [edit]="false"
  [delete]="false"
  [create]="true"
  [details]="false"
  [access]="access()"
></app-permissions-form>
